module.exports = __webpack_public_path__ + "static/img/switch_red.ca77b2dc.png";